var spinner 	='</div><div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div><div class="rect6"></div><div class="rect7"></div><div class="rect8"></div><div class="rect9"></div><div class="rect10"></div></div>';
$(document).ready(function () {
	// Artikel löschen
	$(".wako_del").click(function (){
		var form	= $(this).closest("form");
		var id		= $(this).attr("id").replace("wako_del_","");
		$("input[name=wako_anzahl_" + id +"]").val("0");
		$("button[name=wako_btn_submit_recalculate]").click();
	});
	// Entferne Error Class nach KLICK
	$(".error-line").click(function(){
		$(this).removeClass('error-line');
		$(".cr").removeClass('error-line');
	});
	$(".konto-navigation-button").click(function(){
		$("#konto-navigation").show();
	});
	// Bestellung Details anzeigen
	$(".bestellungen-detail").click(function (){
		var id		= $(this).attr("id").replace("bestellungen_detail_","");
		if ($("#wako_bestellungen_artikel_" + id).html() == '') {
			$("#wako_bestellungen_artikel_" + id).removeClass("d-none");
			$("#wako_bestellungen_artikel_" + id).addClass("d-block");
			$("#wako_bestellungen_artikel_" + id).html(spinner);
			$("#details_oben_" + id).removeClass("d-block");
			$("#details_oben_" + id).addClass("d-none");
			$.ajax ({
				type: 'GET',
				url: '/warenkorb/ajax_bestellung_details',
				data: 'bestellung_id=' + id,
				cache: false,
				success: function (html) {
					$("#wako_bestellungen_artikel_" + id).html(html);
					$("#details_unten_" + id).removeClass("d-none");
					$("#details_unten_" + id).addClass("d-block");
				}
			});
		}
	});
});

// Warenkorb hinzufuegen Funktion
function warenkorb_add(artikel_id,artikel_typ) {
	var wako_text			= 'Ihr Warenkorb wird geladen...';
	$("#shopping-cart-overlay").show();
	$("#shopping-cart-overlay").html(spinner);
	$("#shopping-cart-overlay").append('<div class="text-center mt-4">' + wako_text + '</div>');
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_add_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				$("#wako-count").html($('basket_count', xml).text());
				window.parent.update_wakobox_and_show();
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Artikel konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

//Warenkorb loeschen Funktion
function warenkorb_delete(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_delete_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				$("#wako-count").html($('basket_count', xml).text());
				window.parent.update_wakobox_and_show();
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht gelöscht werden.");
		}
	});
}

// Warenkorb Overlay updaten und anzeigen
function update_wakobox_and_show() {
	$.ajax({
		type: "POST"
		,url: '/warenkorb/ajax_shopping_cart'
		,success: function(html,textStatus){
			$("#shopping-cart-overlay").html(html);
			$("#shopping-cart-overlay").show();
		},
		error: function(){
			alert("Beim Laden des Warenkorbs ist ein Fehler aufgetreten.");
		}
	});
}

// OPEN / CLOSE Wako-Overlay
function close_overlay(element){
	$(element).hide();
}
function open_overlay(element){
	$(element).show();
}

// Anzahl erneuern im Warenkorb
function recount(){
	$("button[name='wako_btn_submit_recalculate']").click();
}

// Toggle Lieferadresse
function toggle_lieferadresse() {
	if ($("input[name='rechnungsadresse_ist_lieferadresse']:checked").val() == '1') {
		$("#wako-form-lieferadresse").hide();
	} else {
		$("#wako-form-lieferadresse").show();
	}
}

// Vorbestellformular toggeln
function show_vorbestellen_form(form_class) {
	$("." + form_class).toggle();
}